var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPm2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 29,
    viewBox: "0 0 92 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4417 0.451172H79.6847C77.9442 0.451172 76.6054 0.986703 75.8021 2.72718L64.8237 27.7633H72.5889C72.5889 27.7633 73.9278 24.4162 74.1955 23.6129C74.9988 23.6129 82.6301 23.6129 83.7012 23.6129C83.969 24.5501 84.6384 27.6294 84.6384 27.6294H91.6003L85.4417 0.451172ZM76.3377 17.9898C77.0071 16.3832 79.2831 10.3585 79.2831 10.3585C79.2831 10.4924 79.9525 8.75191 80.2203 7.81473L80.7558 10.2246C80.7558 10.2246 82.2285 16.7849 82.4963 18.1237H76.3377V17.9898Z",
    fill: "#3362AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3591 18.7934C65.3591 24.4165 60.2716 28.1652 52.3725 28.1652C49.0254 28.1652 45.8123 27.4958 44.0718 26.6925L45.1428 20.5339L46.08 20.9355C48.4899 22.0066 50.0965 22.4082 53.0419 22.4082C55.184 22.4082 57.4601 21.6049 57.4601 19.7306C57.4601 18.5256 56.5229 17.7223 53.5775 16.3835C50.7659 15.0447 47.0172 12.9026 47.0172 9.01996C47.0172 3.66464 52.2386 0.0498047 59.6022 0.0498047C62.4137 0.0498047 64.8236 0.585336 66.2963 1.25475L65.2253 7.1456L64.6897 6.61006C63.3509 6.07453 61.6104 5.539 59.0667 5.539C56.2551 5.67288 54.9163 6.87783 54.9163 7.94889C54.9163 9.15384 56.5229 10.091 59.0667 11.296C63.3509 13.3042 65.3591 15.5802 65.3591 18.7934Z",
    fill: "#3362AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0239258 0.719125L0.157809 0.183594H11.6717C13.2783 0.183594 14.4833 0.719125 14.8849 2.4596L17.4287 14.5091C14.8849 8.08268 8.99408 2.86125 0.0239258 0.719125Z",
    fill: "#F9B50B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6287 0.451266L21.9809 27.6295H14.0818L7.3877 4.8694C12.2075 7.94871 16.224 12.7685 17.6967 16.1156L18.5 18.9271L25.7296 0.317383H33.6287V0.451266Z",
    fill: "#3362AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7084 0.317383H44.0719L39.386 27.6295H32.0225L36.7084 0.317383Z",
    fill: "#3362AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm2);
export default __webpack_public_path__ + "static/media/pm2.548755dfd7a62f58afeb76e09a576f67.svg";
export { ForwardRef as ReactComponent };